import React from "react";
import { Link } from "react-router-dom";

// Full-page error / empty state used across the app.
const ErrorState = ({
  eyebrow = "Something went wrong",
  title,
  message,
  primaryLabel = "Browse episodes",
  primaryTo = "/",
  onRetry,
}) => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16">
      <div className="text-center max-w-md animate-fade-up">
        {/* Muted equalizer illustration */}
        <div
          className="mx-auto mb-8 w-20 h-20 rounded-2xl bg-ink-900 flex items-end justify-center gap-[5px] pb-5 pt-5 px-5"
          aria-hidden="true"
        >
          {[0.5, 0.9, 0.3, 0.7].map((h, i) => (
            <span
              key={i}
              className="w-[5px] rounded-full bg-white/40"
              style={{ height: `${h * 100}%` }}
            />
          ))}
        </div>

        <p className="text-sm font-semibold uppercase tracking-wider text-blue-600 mb-3">
          {eyebrow}
        </p>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-ink-900 mb-4">
          {title}
        </h1>
        <p className="text-slate-500 leading-relaxed mb-8">{message}</p>

        <div className="flex items-center justify-center gap-3 flex-wrap">
          <Link
            to={primaryTo}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold transition-colors duration-200"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M8 5v14l11-7z" />
            </svg>
            {primaryLabel}
          </Link>
          {onRetry && (
            <button
              onClick={onRetry}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-slate-200 bg-white text-ink-900 text-sm font-semibold hover:border-blue-300 hover:text-blue-600 transition-colors duration-200"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              Try again
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorState;
